export default __webpack_public_path__ + "static/media/large.a7cafc18.jpg";